<template>
  <div class="main lh-15 c-fff">
    <div class="container bgs-cover p-r z-3">
      <div class="nav-anchor z-99 l-0 w-100p bgc-fff c-333">
        <div class="h-100p m-a d-f jc-sb ai-c fs-16">
          <strong class="d-f ai-c fs-20 fw-500"
            >FJD Trion V1 Series RTK Rover<span class="in-h5 triangle-icon triangle-icon-fff bgs-cover bgp-c"></span
          ></strong>
          <div class="d-f">
            <div class="nav-anchor-item d-f jc-sb ai-c">
              <a href="/product/trion-v1-series-rtk-rover#overview">Overview</a>
              <a href="/product/trion-v1-series-rtk-rover#feature">Features</a>
            </div>
            <a class="dealer-free-quote-btn d-ib ta-c bgc-222 c-fff in-pc" href="/basicinfo" target="_blank"
              >Free Quote</a
            >
          </div>
        </div>
      </div>
      <!-- nav-anchor:end -->
      <div class="content">
        <h2>Specifications</h2>
        <div class="cont-1 d-f jc-sb">
          <div class="left">
            <h3>Satellite Constellation</h3>
            <hr />
            <table>
              <tr>
                <td>Channels</td>
                <td>965</td>
              </tr>
              <tr>
                <td>GPS</td>
                <td>L1C/A, L2P, L2C, L5, L1C</td>
              </tr>
              <tr>
                <td>BDS-2</td>
                <td>B1l, B2l, B3l, B1C, B2a, B2b</td>
              </tr>
              <tr>
                <td>BDS-3</td>
                <td>B1I, B3I, B1C, B2a, B2b</td>
              </tr>
              <tr>
                <td>GLONASS</td>
                <td>G1, G2, G3</td>
              </tr>
              <tr>
                <td>Galileo</td>
                <td>E1, E5a, E5b, E6</td>
              </tr>
              <tr>
                <td>QZSS</td>
                <td>L1C, L2, L5, L1C/A</td>
              </tr>
              <tr>
                <td>SBAS</td>
                <td>L1C/A, L5*</td>
              </tr>
              <tr>
                <td>IRNSS</td>
                <td>L5*</td>
              </tr>
              <tr>
                <td>L-band*</td>
                <td></td>
              </tr>
            </table>
            <h3>Receiver</h3>
            <hr />
            <table>
              <tr>
                <td>Size & Weight</td>
                <td>162*86 mm; 1 kg</td>
              </tr>
              <tr>
                <td>IP rating</td>
                <td>IP67</td>
              </tr>
            </table>
            <h3>Battery</h3>
            <hr />
            <table>
              <tr>
                <td>Battery capacity & life</td>
                <td>
                  6700 mAh; <br />
                  Static: 15 h, Rover: 10 h
                </td>
              </tr>
            </table>
          </div>
          <div class="right">
            <h3>Bluetooth</h3>
            <hr />
            <table>
              <tr>
                <td>Protocol</td>
                <td>BT4.2 & BLE</td>
              </tr>
            </table>
            <h3>Built-in Radio</h3>
            <hr />
            <table>
              <tr>
                <td>Power consumption</td>
                <td>0.5 W/1 W</td>
              </tr>
              <tr>
                <td>Frequency</td>
                <td>410 MHz - 470 MHz</td>
              </tr>
              <tr>
                <td>Protocol</td>
                <td>
                  TRIMTALK, TRIMMARKIII, <br />
                  TT450S, TRANSEOT
                </td>
              </tr>
            </table>
            <h3>Power Supply</h3>
            <hr />
            <table>
              <tr>
                <td>Voltage</td>
                <td>
                  Rated input voltage: 12 V DC;<br />
                  Input voltage range: 5 V - 36 V
                </td>
              </tr>
            </table>
            <h3>Ambient Environment</h3>
            <hr />
            <table>
              <tr>
                <td>Operating temperature</td>
                <td>-30 ℃ - 60 ℃</td>
              </tr>
              <tr>
                <td>Storage temperature</td>
                <td>-40 ℃ - 75 ℃</td>
              </tr>
              <tr>
                <td>Humidity</td>
                <td>95%</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="cont-2">
          <h3>Positioning Performance</h3>
          <hr />
          <table>
            <tr>
              <td>Single positioning (RMS)</td>
              <td>Horizontal 1.5 m, <br class="in-h5" />vertical 3 m;</td>
            </tr>
            <tr>
              <td>Static differential (RMS)</td>
              <td>Horizontal ± (2.5+0.5*10-6*D) mm, <br class="in-h5" />vertical ± (5+0.5*10-6*D) mm</td>
            </tr>
            <tr>
              <td>RTK (RMS)</td>
              <td>Horizontal ± (8+1*10-6*D) mm, <br class="in-h5" />vertical ± (15+1*10-6*D) mm</td>
            </tr>
            <tr>
              <td>Tilt Survey with IMU (V1t)</td>
              <td>Precision 2.5cm with an angle of 30°</td>
            </tr>
            <tr>
              <td>Update rate</td>
              <td>Raw observation data: <br class="in-h5" />1, 2, 5, 10 Hz</td>
            </tr>
            <tr>
              <td></td>
              <td>Real-time positioning data: <br class="in-h5" />1, 2, 5, 10 Hz</td>
            </tr>
            <tr>
              <td>Data format</td>
              <td>RTCM2.X, RTCM3.X, CMR, <br class="in-h5" />CMR+, CMRx, NMEA-0183, RINEX</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="pic p-a bgs-cover bgp-c"></div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    head() {
      return {
        title: 'FJD Trion V1 series RTK Rover',
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'FJD Trion V1 series RTK Rover'
          },
          // hid is used as unique identifier. Do not use `vmid` for it as it will not work
          {
            hid: 'description',
            name: 'description',
            content:
              'FJD Trion V1 series, a versatile and lightweight GNSS RTK receiver, can fast deliver accurate positions in harsh environments with global signal coverage. V1t, the advanced version, is engineered with an Inertial Measurement Unit (IMU) that frees you up from watching and leveling the bubble when measuring.'
          }
        ]
      }
    },
    created() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  @media screen and (min-width: 768px) {
    .fs-40 {
      font-size: 0.4rem;
    }
    .fs-20 {
      font-size: 0.2rem;
    }
    .fs-18 {
      font-size: 0.18rem;
    }
    .fs-16 {
      font-size: 0.16rem;
    }
    .container {
      margin-top: 0.76rem;
      height: 16.91rem;
      background-image: url('@/assets/images/trion-v1-series-rtk-rover/specs-bg.jpg');
    }
    .container .pic {
      width: 3.63rem;
      height: 12.25rem;
      top: 4.66rem;
      left: 1.48rem;
      background-image: url('@/assets/images/trion-v1-series-rtk-rover/specs-pic.png');
    }
    .content {
      padding: 1.19rem 2.24rem 0 6.83rem;
    }
    /* nav-anchor */
    .nav-anchor {
      height: 0.56rem;
      top: 0.75rem;
      position: sticky;
      box-shadow: 0px 0.02rem 0.04rem 0px rgba(0, 0, 0, 0.1);
    }
    .nav-anchor > div {
      padding-left: 1.6rem;
      padding-right: 1.6rem;
    }
    .nav-anchor a {
      margin-left: 0.8rem;
    }
    .nav-anchor .nav-anchor-item a:hover {
      font-weight: 700;
    }
    .nav-anchor .dealer-free-quote-btn {
      width: 1.2rem;
      line-height: 0.32rem;
      transition: background-color 0.3s linear;
    }
    .nav-anchor .dealer-free-quote-btn:hover {
      color: #fff;
      background-color: rgba(34, 34, 34, 0.85);
    }

    .content .cont-1 > div {
      width: 4.47rem;
    }
    .content h2 {
      font-size: 0.48rem;
      margin-bottom: 0.5rem;
    }
    .content h3 {
      font-size: 0.24rem;
    }
    .content hr {
      margin: 0.16rem 0 0.31rem;
      background-color: transparent;
      height: 1px;
      border: none;
      border-top: 1px solid #fff;
    }
    .content table {
      width: 100%;
      margin-bottom: 0.64rem;
    }
    .content table td {
      padding: 0.06rem 0;
    }
    .content table td:nth-child(2n + 1) {
      font-weight: 500;
      vertical-align: top;
    }
    .content table td:nth-child(2n) {
      text-align: right;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 1100px) {
    .content {
      padding-top: 0.5rem;
    }
  }
</style>
